import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_role_pricing_scheme_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    role_guid: fromDatatype.GuidDataFieldInterface;
    pricing_scheme_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    sales_price_read: boolean;
    sales_price_update:boolean;
    purchase_price_read:boolean;
    purchase_price_update:boolean;
    descr: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_applet_role_pricing_scheme_link_RowClass implements bl_applet_role_pricing_scheme_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    role_guid: fromDatatype.GuidDataFieldInterface;
    pricing_scheme_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    sales_price_read: boolean;
    sales_price_update:boolean;
    purchase_price_read:boolean;
    purchase_price_update:boolean;
    descr: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}